module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-regionals/master-regionals.component.scss
// module id = ./src/app/master/master-regionals/master-regionals.component.scss
// module chunks = main